<template>
    <v-avatar v-if="type === 'public'" color="grey darken-1" :size="size">
        <v-icon :size="iconSize" dark>mdi-earth</v-icon>
    </v-avatar>
    <v-avatar v-else-if="type === 'team'" color="grey darken-1" :size="size">
        <v-icon :size="iconSize" dark>mdi-account-supervisor</v-icon>
    </v-avatar>
    <v-avatar v-else-if="type === 'direct'" :color="avatarBackground" :size="size">
        <span :class="['headline', { 'white--text': this.isWhiteText() }]">{{ avatarText }}</span>
    </v-avatar>
</template>

<script>
    export default {
        name: 'MessageAvatar',
        props: {
            type: {
                type: String,
                required: true,
                validator (value) {
                    return ['direct', 'team', 'public'].indexOf(value) !== -1
                },
            },
            text: {
                type: String,
                required: false,
            },
            background: {
                type: String,
                required: false,
            },
            size: {
                type: Number,
                required: false,
                default () {
                    return 54;
                },
            },
        },
        computed: {
            avatarBackground () {
                return this.stringToColor(this.text);
            },
            avatarText () {
                let text = this.text.toLowerCase()
                    .split(' ')
                    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                    .join(' ');

                if (text.length < 2) {
                    text = this.text.toUpperCase();
                }

                return text.substr(0, 2);
            },
            iconSize () {
                return this.size * 0.75;
            },
        },
        methods: {
            stringToColor (str) {
                let hash = 0;
                for (let i = 0; i < str.length; i++) {
                    hash = str.charCodeAt(i) + ((hash << 5) - hash);
                }
                let colour = '#';
                for (let i = 0; i < 3; i++) {
                    let value = (hash >> (i * 8)) & 0xFF;
                    colour += ('00' + value.toString(16)).substr(-2);
                }
                return colour;
            },
            isWhiteText () {
                return (parseInt(this.avatarBackground.replace('#', ''), 16) < 0xffffff / 2);
            },
        },
    }
</script>
